import React, { createContext, useContext, useState, useEffect } from 'react'
import { type Lang } from '../i18n/translations'

interface LangContextValue {
  lang: Lang
  setLang: (l: Lang) => void
}

const LanguageContext = createContext<LangContextValue>({ lang: 'zh', setLang: () => {} })

export function LanguageProvider({ children }: { readonly children: React.ReactNode }) {
  const [lang, setLangState] = useState<Lang>('zh')

  useEffect(() => {
    const saved = localStorage.getItem('holo-lang') as Lang | null
    if (saved === 'en' || saved === 'zh') setLangState(saved)
  }, [])

  const setLang = (l: Lang) => {
    setLangState(l)
    localStorage.setItem('holo-lang', l)
  }

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
